import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';
import { browserHistory } from 'react-router';

const PartnerAccessFrequencyGauge = (props) => (
  <KpiChart
    title={
      props.usersLink ? (
        <>
          <span>Access frequency</span>
          <span
            href="#"
            onClick={() => browserHistory.push(props.usersLink)}
            style={{
              fontSize: 14,
              marginLeft: 15,
              fontWeight: 'normal',
              textDecoration: 'underline',
              cursor: 'pointer',
              color: 'royalblue',
            }}
          >
            View Users
          </span>
        </>
      ) : (
        'Access frequency'
      )
    }
    description="The number represents the frequency of access for each user divided by the number of users who have at least one access in the month. The frequency of access for each user is defined by the number of days in the reference month divided by the number of days the user accessed."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 7, 14, 21]}
    stepSize={7}
    reverseColors={true}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

PartnerAccessFrequencyGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  usersLink: PropTypes.string,
  formatter: PropTypes.func.isRequired,
};

PartnerAccessFrequencyGauge.defaultProps = {
  onClickHistory: null,
  usersLink: null,
};

export default PartnerAccessFrequencyGauge;
